import { useCallback } from 'react';
import { Pencil, Trash2 } from 'lucide-react';
/**
 * Hook for generating project-specific context menu items
 * Provides edit and remove functionality with proper status-based enabling
 */
export const useProjectContextMenu = (options) => {
    const generateProjectMenuItems = useCallback((project) => {
        // Mirrors the backend rule (flow.go canRemoveProject): only purchased
        // ("paid") projects are removal-proof — deleting one would destroy data
        // the owner paid real money for — and failed projects are kept for
        // debugging. Everything else (free demos, Atlas-included "credited"
        // projects, admin gifts) is the owner's to delete. Demo deletion is not a
        // free-retry loophole: the issuance survives, so the area stays spent.
        // Shares and workspace-seat views are never deletable by the viewer.
        const canRemove = project.isOwner !== false &&
            project.displayStatus !== 'failed' &&
            project.paymentStatus !== 'paid';
        return [
            {
                id: 'edit-project',
                label: 'Edit Project',
                icon: Pencil,
                action: () => { var _a; return (_a = options.onEditProject) === null || _a === void 0 ? void 0 : _a.call(options, project); },
                disabled: false,
                separator: false
            },
            {
                id: 'remove-project',
                label: 'Remove Project',
                icon: Trash2,
                action: () => { var _a; return (_a = options.onRemoveProject) === null || _a === void 0 ? void 0 : _a.call(options, project); },
                disabled: !canRemove,
                separator: true // Add separator before remove option
            }
        ];
    }, [options.onEditProject, options.onRemoveProject]);
    return { generateProjectMenuItems };
};
